export const ActionTypes = {
    SET_PATIENTDETAILS: "SET_PATIENTDETAILS",
    SET_APPOINTMENTTYPE: "SET_APPOINTMENTTYPE",
    SET_SLOTSELECTION: "SET_SLOTSELECTION",
    SET_INSURANCE: "SET_INSURANCE",
}